import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const visitSchema = z.object({
  pagePath: z.string().trim().min(1).max(300),
  profile: z.string().trim().max(60).optional().or(z.literal("")),
  utmCampaign: z.string().trim().max(120).optional().or(z.literal("")),
  utmContent: z.string().trim().max(120).optional().or(z.literal("")),
  utmSource: z.string().trim().max(80).optional().or(z.literal("")),
  utmMedium: z.string().trim().max(80).optional().or(z.literal("")),
  referrer: z.string().trim().max(300).optional().or(z.literal("")),
});

/**
 * Records a visit that arrived from a tagged Google Business Profile link.
 * Counts only — no personal data, no cookies, nothing identifying the visitor.
 */
export const recordGbpVisit = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => visitSchema.parse(data))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { error } = await supabaseAdmin.from("gbp_visits").insert({
      page_path: data.pagePath,
      profile: data.profile || null,
      utm_campaign: data.utmCampaign || null,
      utm_content: data.utmContent || null,
      utm_source: data.utmSource || null,
      utm_medium: data.utmMedium || null,
      referrer: data.referrer || null,
    });

    if (error) {
      console.error("Failed to record GBP visit", error);
      return { ok: false } as const;
    }

    return { ok: true } as const;
  });
